// eslint-disable-next-line import/prefer-default-export
export const ROOT_ID = "charter_root";
